export const COLOUR_THEMES = [
  'default',
  'green',
  'red',
  'cyan',
  'gold',
  'polar-green',
  'light-green',
  'purple',
  'orange',
] as const;

export const EMBED_THEME_PARAMS = {
  mode: 'mode',
  theme: 'theme',
} as const;

export const EMBED_THEME_STORAGE_KEY = 'fab-embed-theme';

export const EMBED_THEME_MESSAGE = 'FAB_THEME_CHANGE';

export const FORM_SURFACE_PRIMARY = '#5550ff';
